import { Button } from '../../components/Button';
import { useUserData } from '@/contexts/UserDataContext';

interface HoursADayStepProps {
    onNext: () => void;
}

export const HoursADayStep = ({ onNext }: HoursADayStepProps) => {
    const { updateUserData } = useUserData();
    const options = [
        { label: "less than 1 hour per day", value: 12 },
        { label: "1 hour per day", value: 24 },
        { label: "2 hours per day", value: 49 },
        { label: "3 hours per day", value: 73 },
        { label: "more than 4 hours per day", value: 97 }
    ];
    return (
        <div className="shrink-0 flex flex-col gap-2 justify-center items-center w-full px-8">
            {options.map((option) => (
                <Button key={option.value} label={option.label} onClick={() => {
                    updateUserData({ totalLostDays: option.value });
                    onNext();
                }} variant='outlined' className='!border-osBlack !font-normal' />
            ))}
        </div>
    );
};
